// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"94fd525c","522":"d5bd9e54","600":"703d01f4","692":"df9295df","747":"5f7d01d1","833":"5c04aeda"}[chunkId] + ".chunk.js";
};